import { Box, IconButton, Modal } from "@mui/material";
import { useApp } from "../../hooks/useApp";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";

export default function MockPc() {
  const { activeMockPc, setActiveMockPc } = useApp();
  const handleClose = () => {
    setActiveMockPc(null);
  };
  return (
    <React.Fragment>
      <Modal
        open={!!activeMockPc}
        onClose={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
        disableAutoFocus
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "100%",
            height: "100%",
            bgcolor: "background.paper",
            boxShadow: 24,
          }}
        >
          <IconButton
            onClick={handleClose}
            size="large"
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              zIndex: 1000,
              backgroundColor: "#000",
              color: "#fff",
              "&:hover": {
                backgroundColor: "#333",
                color: "#fff",
              },
            }}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
          <iframe
            src={activeMockPc}
            title="lib"
            allowFullScreen
            style={{
              width: "100%",
              height: "100%",
              border: "none",
            }}
          />
        </Box>
      </Modal>
    </React.Fragment>
  );
}
